<template>
  <v-col style="padding: 2px" :cols="cols">
    <v-hover>
      <template #default="{hover}">
        <v-card
          :class="`${clickable && hover? 'cursor-pointer' : ''}`"
          color="color-5"
        >
        <!-- :elevation="clickable && hover? 12:2" -->
          <v-container class="pa-0">
          <slot name="badge"/>
          <div v-if="icon" class="standard-card-icon">
            <div class="standard-card-icon-center">
              <v-icon x-large>{{icon}}</v-icon> <br>
              <span class="headline white--text shadow" v-text="name"></span>
            </div>
          </div>
          <v-img
            v-else
            class="standard-card-img"
            :src="image"
            height="200px"
            style="position: relative;"
            >
            <!-- gradient="to top,rgba(0, 0, 0, 0),rgba(0, 0, 0, 0.05),rgba(0, 0, 0, 0.4)" -->
            <div
              class="standard-card-img-gradient pa-3"
              :style="
              hover?
              'background: rgba(0,0,0,0.5);'
              :
              ($slots.description?
              'background: linear-gradient(to top,rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.1),rgba(0, 0, 0, 0.4)), linear-gradient(to left,rgba(0, 0, 0, 0),rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.2),rgba(0, 0, 0, 0.4));'
              :'')
              "
              >
              <v-progress-circular v-if="loading" :size="100" width="6"  indeterminate class="loading-circle white--text"/>
              <v-layout justify-start>
                  <span class="headline standard-card-text" v-text="name"></span>
              </v-layout>
              <v-layout justify-start>
                <slot name="description"/>
              </v-layout>
            </div>
          </v-img>
          <slot name="info"/>
          </v-container>
        </v-card>
      </template>
    </v-hover>
  </v-col>
</template>
<script>
export default {
  props: ['image', 'name', 'loading', 'cols', 'clickable', 'icon', 'width'],
  data: () => ({
  }),
}
</script>
<style lang="scss" scoped>
.standard-card-text {
  text-shadow: 0px 1px #000;
  color: rgba(255,255,255, 0.9)
}
.standard-card-icon {
  height: 200px;
}
.standard-card-icon-center {
  text-align: center;
  padding-top: 15% !important;
  padding: 10px;
}
.loading-circle {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.standard-card-img-gradient {
  height: 100%;
  background: linear-gradient(to top,rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.1),rgba(0, 0, 0, 0.4));
  // transition: background 0.3s ease-in-out;
}
</style>
